import BaseTour from './tour/BaseTour';
import { TourType } from '@/_models/Tour';

export default class PublicTour extends BaseTour {
  constructor(props: any) {
    super(props, TourType.Regular);
  }

  componentDidMount() {
    const { tour, matterId, tourData } = this.props;

    if (tour) {
      // preview of the tour, load from props
      this.loadData(tour);
    } else {
      this.getTour({ id: matterId, tourData });
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.takePosition);
    document.removeEventListener('contextmenu', this.disableContext);
  }
}
